import React, { useState } from 'react';
import { Panel, PanelTheme, PanelBorderRadius, PanelBorderStyle } from '@apply/components';
import { AddReferralButton } from './components/AddReferralButton';
import { AcceptedReferralTable } from './components/tables/AcceptedReferralTable';
import { PendingReferralTable } from './components/tables/PendingReferralTable';
import { WaitingReferralTable } from './components/tables/WaitingReferralTable';
import { isMobileScreen } from '@apply/ui';
import { ReferralSearchTextBox } from './components/ReferralSearchTextBox';
import './scss/_brokerActivatedPanel.scss';

export const BrokerActivatedPanel: React.FC = () => {
    const [searchText, set_SearchText] = useState('');
    const mobileScreen = isMobileScreen();

    return (
        <>
            <div className='brokerReferrals'>
                <div className='brokerReferrals-header'>
                    <div className={`brokerReferrals-header-title ${mobileScreen ? 'mobile' : ''}`}>
                        <h2>Referrals</h2>
                        {!mobileScreen && (
                            <div className='brokerReferrals-sectionDirections'>
                                These are the current referrals you have provided to the Builder Finance team and their status.
                            </div>
                        )}
                    </div>
                    <div className='brokerReferrals-header-action'>{!mobileScreen && <AddReferralButton />}</div>
                </div>
                <div className='brokerReferrals-sectionPanel'>
                    <Panel
                        theme={PanelTheme.White}
                        borderStyle={PanelBorderStyle.None}
                        borderRadius={PanelBorderRadius.Small}
                    >
                        {mobileScreen && (
                            <div style={{ paddingBottom: '20px', display: 'flex', justifyContent: 'center' }}>
                                <AddReferralButton />
                            </div>
                        )}
                        <ReferralSearchTextBox
                            value={searchText}
                            onChange={set_SearchText}
                        />
                        <div className='brokerReferrals-tables'>
                            <PendingReferralTable searchText={searchText} />
                            <WaitingReferralTable searchText={searchText} />
                            <AcceptedReferralTable searchText={searchText} />
                        </div>
                    </Panel>
                </div>
            </div>
        </>
    );
};
